module.exports = __webpack_public_path__ + "tickets-svgrepo-com.svg?247d29d864a5a5a67e98e1bdfb7c2251";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tickets-svgrepo-com.svg
// module id = 68
// module chunks = 0